import ReactFadeImage from '.';

export default ReactFadeImage;
